import LegalLayout from "../components/LegalLayout";
import Markdown from "../components/Markdown";
import { useParams } from "react-router-dom";
import { useContent } from "../context/ContentContext";

/**
 * Creator-eigenes Impressum unter /creator/:slug/impressum
 * Text kommt aus content.creators[i].impressum (per Admin Panel oder SQL).
 * Enthält der Text keine Markdown-Überschrift ("#" am Anfang), wird er als
 * reiner Text mit Zeilenumbrüchen dargestellt — so wie eingegeben.
 */
export default function CreatorImpressum() {
  const { slug } = useParams();
  const { content } = useContent();
  const creators = content?.creators || [];

  const slugify = (s = "") =>
    s.toString().toLowerCase().trim()
      .replace(/[^\w\s-]/g, "")
      .replace(/[\s_-]+/g, "-")
      .replace(/^-+|-+$/g, "");

  const creator = creators.find((c) => (c.slug || slugify(c.name)) === slug);

  if (!creator) {
    return (
      <LegalLayout eyebrow="Legal" title="Impressum" updated="">
        <p className="text-zinc-400">
          Kein Impressum für „{slug}" gefunden. <a href="/" className="text-[#ff0033] hover:underline">Zurück zur Startseite</a>
        </p>
      </LegalLayout>
    );
  }

  const body = creator.impressum || buildDefaultImpressum(creator);
  const updated = creator.impressum_updated || "";
  const isMarkdown = /^#\s|^##\s/m.test(body);

  return (
    <LegalLayout eyebrow={`Legal · ${creator.name}`} title="Impressum" updated={updated}>
      {isMarkdown ? (
        <Markdown source={body} />
      ) : (
        <div className="text-zinc-300 leading-relaxed whitespace-pre-wrap text-base">
          {body}
        </div>
      )}
    </LegalLayout>
  );
}

function buildDefaultImpressum(c) {
  const email = c.impressum_email || c.email || "info@strassenwert.de";
  const name = c.impressum_name || c.name;
  return `# IMPRESSUM

Angaben gemäß § 5 Digitale-Dienste-Gesetz (DDG)

## Straßenwert

Maurizio Rogait
Kolonnenstraße 8
10827 Berlin
Deutschland

E-Mail: info@strassenwert.de

Vertreten durch den Inhaber: **Maurizio Rogait**

Management / geschäftliche Anfragen: **management@strassenwert.de**

## Creator Management

**${name}**
Creator-E-Mail: **${email}**

Bitte keine Fanpost und/oder Autogrammwünsche.

Geschäftliche Anfragen bitte ausschließlich an:
**management@strassenwert.de**

## Verantwortlich für den Inhalt

${name}
c/o Straßenwert
Kolonnenstraße 8
10827 Berlin
Deutschland

E-Mail: ${email}

## Redaktionell verantwortlich nach § 18 Abs. 2 MStV

${name}
c/o Straßenwert
Kolonnenstraße 8
10827 Berlin
Deutschland

E-Mail: ${email}
`;
}
